import ApiClient from "@/domain/core/utils/apiClient";
import client_core from "@/services/clients/client_core";
import client_gateway from "@/services/clients/client_gateway";

const client = new ApiClient(client_core)
const gatewayClient = new ApiClient(client_gateway)

const endpoints = {
    create: `/dashboard/v2/user/register/`,
    login: `/dashboard/v2/user/login/`,
    token_auth: '/dashboard/v1/auth/?include_jwt=true',
    convert_token: '/auth/convert-token/?include_jwt=true',
    jwt: '/v2/user/jwt/',
    user: '/dashboard/v1/users/me/?include_perms=true&include_groups=true',
    change_password: '/api/v1/password/change/',
    invitation_preview: '/dashboard/api/v3/invitations/preview/',
    invitation_accept: '/dashboard/api/v3/invitations/accept/',
    config: '/dashboard/v2/config/{type}/?id={id}',
    resend_registration_token: '/dashboard/v2/user/resend_registration_token/',
    validate_registration_code: '/dashboard/v2/user/validate_registration_token/',
    send_login_token: '/api/v1/auth/token/request/',
    login_with_token: '/api/v1/auth/token/verify/?include_jwt=true',
    become_saas: '/dashboard/v2/user/become_saas/',
}

export default {
    async createUser(email) {
        return await client.post(endpoints.create, {email})
    },
    async getAuthToken(username, password, allowRegister) {
        return await client.post(endpoints.login, {username, password, allow_register: allowRegister})
    },
    async convertAuthToken(payload) {
        return await client.post(endpoints.convert_token, payload)
    },
    async getUserData() {
        return await client.get(endpoints.user, {
            includePerms: true,
            includeGroups: true
        })
    },
    async changePassword(password, passwordRepeat) {
        await client.post(endpoints.change_password, {
            'new_password1': password,
            'new_password2': passwordRepeat,
        })
    },
    async changeUserData({first_name, last_name, language, timezone}) {
        await client.patch(endpoints.user, {
            first_name,
            last_name,
            language,
            timezone
        })
    },
    async previewInvitation(code, email) {
        return await client.get(endpoints.invitation_preview, {
            code: code,
            email: email
        })
    },
    async acceptInvitation(code, email) {
        return  await client.post(endpoints.invitation_accept, {
            code: code,
            email: email
        })
    },
    async getJwt() {
        const response = await client.get(endpoints.jwt)
        return response.jwt
    },
    async getConfig(type, id) {
        return await client.get(endpoints.config.replace('{type}', type).replace('{id}',id))
    },
    async resendValidationCode(email) {
        return await client.post(endpoints.resend_registration_token, {email})
    },
    async validateCode(email, code) {
        return await client.post(endpoints.validate_registration_code, {email, token: code})
    },
    async sendLoginToken(email) {
        return await client.post(endpoints.send_login_token, {email})
    },
    async loginWithToken(email, token) {
        return await client.post(endpoints.login_with_token, {email, token})
    },
    async authenticateLdap(username, password) {
        return await gatewayClient.post('/auth/ldap/tokens/', {username, password})
    },
    async refreshLdapToken(refresh_token) {
        return await gatewayClient.post('/auth/tokens/refresh/', {refresh_token})
    },
    async revokeLdapToken(refresh_token, revoke_all_devices = false) {
        return await gatewayClient.post('/auth/tokens/revoke/', {
            refresh_token,
            revoke_all_devices
        })
    },
    /**
     * Upgrade utente a SAAS - crea ContractManager con is_saas=true
     * @returns {Promise<{contract_manager_id: number}>}
     */
    async becomeSaas() {
        return await client.post(endpoints.become_saas)
    }
}
